var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"luck-logo"},[_c('img',{staticClass:"luck-logo-img",attrs:{"src":require("@/assets/luck-logo.png"),"alt":"Luck Receptivo"}})])
}]

export { render, staticRenderFns }